import type { TaskResult } from "../types";

export async function gradeProject12(): Promise<TaskResult[]> {
  const results: TaskResult[] = [];

  // Tarea 1: Combinar celdas A1:E1 en la hoja "Pesca"
  try {
    await Excel.run(async (context) => {
      const ws = context.workbook.worksheets.getItem("Pesca");
      const range = ws.getRange("A1:E1");
      const mergedAreas = range.getMergedAreasOrNullObject();
      mergedAreas.load("areaCount");
      await context.sync();

      // If all 5 cells are merged into one area, areaCount = 1
      // If not merged, areaCount = 5 (each cell is its own area)
      const passed = !mergedAreas.isNullObject && mergedAreas.areaCount === 1;
      results.push({ taskId: 1, passed });
    });
  } catch {
    results.push({ taskId: 1, passed: false });
  }

  // Tarea 2: Hipervínculo en B13 de "Tiendas de campaña" → Pesca!A4
  try {
    await Excel.run(async (context) => {
      const ws = context.workbook.worksheets.getItem("Tiendas de campaña");
      const cell = ws.getRange("B13");
      cell.load("hyperlink");
      await context.sync();

      let passed = false;
      const hyperlink = cell.hyperlink;
      if (hyperlink && hyperlink.documentReference) {
        const ref = hyperlink.documentReference.toUpperCase();
        passed = ref.includes("PESCA") && ref.includes("A4");
      }
      results.push({ taskId: 2, passed });
    });
  } catch {
    results.push({ taskId: 2, passed: false });
  }

  // Tarea 3: Formato condicional con conjunto de iconos de 3 banderas en C4:C11 (todas las filas)
  // Verify by checking both the full range AND the last cell individually
  try {
    await Excel.run(async (context) => {
      const ws = context.workbook.worksheets.getItem("Tiendas de campaña");

      // Check formats on the full range
      const fullFormats = ws.getRange("C4:C11").conditionalFormats;
      fullFormats.load("items");
      // Check formats on the last cell to ensure full coverage
      const lastCellFormats = ws.getRange("C11").conditionalFormats;
      lastCellFormats.load("items");
      await context.sync();

      const hasFlags = (formats: Excel.ConditionalFormatCollection): boolean => {
        for (const fmt of formats.items) {
          if (fmt.type === Excel.ConditionalFormatType.iconSet) {
            return true;
          }
        }
        return false;
      };

      // First check: iconSet exists on the range
      if (!hasFlags(fullFormats) || !hasFlags(lastCellFormats)) {
        results.push({ taskId: 3, passed: false });
        return;
      }

      // Second check: verify it's 3 flags style
      for (const fmt of fullFormats.items) {
        if (fmt.type === Excel.ConditionalFormatType.iconSet) {
          fmt.iconSet.load("style");
          await context.sync();
          const style = String(fmt.iconSet.style).toLowerCase();
          results.push({
            taskId: 3,
            passed: style === "threeflags" || style === "3flags",
          });
          return;
        }
      }

      results.push({ taskId: 3, passed: false });
    });
  } catch {
    results.push({ taskId: 3, passed: false });
  }

  // Tarea 4: Expandir rango de datos del gráfico para incluir B7:C7
  try {
    await Excel.run(async (context) => {
      const ws = context.workbook.worksheets.getItem("Tiendas de campaña");
      const charts = ws.charts;
      charts.load("items");
      await context.sync();

      let passed = false;
      if (charts.items.length > 0) {
        const chart = charts.items[0];
        const series0 = chart.series.getItemAt(0);
        series0.points.load("count");
        await context.sync();

        // Initially 3 points (B4:C6), after expansion should be 4+ (includes B7:C7)
        passed = series0.points.count >= 4;
      }
      results.push({ taskId: 4, passed });
    });
  } catch {
    results.push({ taskId: 4, passed: false });
  }

  // Tarea 5: Aplicar Estilo 4 al gráfico (chart.style = 204)
  try {
    await Excel.run(async (context) => {
      const ws = context.workbook.worksheets.getItem("Tiendas de campaña");
      const charts = ws.charts;
      charts.load("items");
      await context.sync();

      let passed = false;
      if (charts.items.length > 0) {
        const chart = charts.items[0];
        chart.load("style");
        await context.sync();

        passed = chart.style === 204;
      }
      results.push({ taskId: 5, passed });
    });
  } catch {
    results.push({ taskId: 5, passed: false });
  }

  return results;
}
